module.exports = __webpack_public_path__ + "img/unit-process-hierarchy.c0881288.png";